import { render, staticRenderFns } from "./FacturesClient.vue?vue&type=template&id=314049f1"
import script from "./FacturesClient.vue?vue&type=script&lang=js"
export * from "./FacturesClient.vue?vue&type=script&lang=js"
import style0 from "./FacturesClient.vue?vue&type=style&index=0&id=314049f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports